import React from "react";
//import shopping from "../images/shopping.svg";
import photo1 from "../images/photo2.jpg";
import photo2 from "../images/photo1.jpg";
import photo3 from "../images/photo3.jpg";
import photo4 from "../images/photo4.jpg";
import photo5 from "../images/photo5.jpg";
import photo6 from "../images/photo6.jpg";
const products = () => {
  return (
    <div>
      <section id="service">
        <div className="container my-5 py-5">
          <div className="row">
            <div className="col-12">
              <h3 className="fs-15 text-center mb-0">Refresh Your Home With Our Products</h3>
              <h1 className="display-6 text-center mb-4">
                <b>
                  Beauty Your <b>Spaces</b>
                </b>
              </h1>
              <hr className="w-25 mx-auto"></hr>
            </div>
            <div className="row">
              <div className="col-md-4">
                <div className="card">
                  <img className="card-img-top" src={photo1} alt="Card cap"  height="500px"/>
                  <div className="card-body pt-5">
                    <h5 className="card-title">Textile Products</h5>
                    <button className="btn btn-outline-primary">
                      Add to Cart
                    </button>
                    <button className="btn btn-warning pt-1 mt-gap">
                      <i className="fa fa-inr">85</i>
                    </button>
                    <button className="btn btn-primary pt-1 mt-gap color-white">
                      <a href="/services/products/productdesc">
                        View Products
                      </a>
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card">
                  <img className="card-img-top" src={photo2} alt="Card cap"  height="500px"/>
                  <div className="card-body pt-5">
                    <h5 className="card-title">Textile Products</h5>
                    <button className="btn btn-outline-primary">
                      Add to Cart
                    </button>
                    <button className="btn btn-warning pt-1 mt-gap">
                      <i className="fa fa-inr">85</i>
                    </button>
                    <button className="btn btn-primary pt-1 mt-gap color-white">
                      <a href="/services/products/productdesc">
                        View Products
                      </a>
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card">
                  <img className="card-img-top" src={photo3} alt="Card cap"  height="500px"/>
                  <div className="card-body pt-5">
                    <h5 className="card-title">Textile Products</h5>
                    <button className="btn btn-outline-primary">
                      Add to Cart
                    </button>
                    <button className="btn btn-warning pt-1 mt-gap">
                      <i className="fa fa-inr">85</i>
                    </button>
                    <button className="btn btn-primary pt-1 mt-gap color-white">
                      <a href="/services/products/productdesc">
                        View Products
                      </a>
                    </button>
                  </div>
                </div>
              </div>
              </div>
              <div className="row">
              <div className="col-md-4">
                <div className="card">
                  <img className="card-img-top" src={photo4} alt="Card cap"  height="500px"/>
                  <div className="card-body pt-5">
                    <h5 className="card-title">Textile Products</h5>
                    <button className="btn btn-outline-primary">
                      Add to Cart
                    </button>
                    <button className="btn btn-warning pt-1 mt-gap">
                      <i className="fa fa-inr">85</i>
                    </button>
                    <button className="btn btn-primary pt-1 mt-gap color-white">
                      <a href="/services/products/productdesc">
                        View Products
                      </a>
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card">
                  <img className="card-img-top" src={photo5} alt="Card cap"  height="500px"/>
                  <div className="card-body pt-5">
                    <h5 className="card-title">Textile Products</h5>
                    <button className="btn btn-outline-primary">
                      Add to Cart
                    </button>
                    <button className="btn btn-warning pt-1 mt-gap">
                      <i className="fa fa-inr">85</i>
                    </button>
                    <button className="btn btn-primary pt-1 mt-gap color-white">
                      <a href="/services/products/productdesc">
                        View Products
                      </a>
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card">
                  <img className="card-img-top" src={photo6} alt="Card cap"  height="500px"/>
                  <div className="card-body pt-5">
                    <h5 className="card-title">Textile Products</h5>
                    <button className="btn btn-outline-primary">
                      Add to Cart
                    </button>
                    <button className="btn btn-warning pt-1 mt-gap">
                      <i className="fa fa-inr">85</i>
                    </button>
                    <button className="btn btn-primary pt-1 mt-gap color-white">
                      <a href="/services/products/productdesc">
                        View Products
                      </a>
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card">
                  <img className="card-img-top" src={photo6} alt="Card cap"  height="500px"/>
                  <div className="card-body pt-5">
                    <h5 className="card-title">Textile Products</h5>
                    <button className="btn btn-outline-primary">
                      Add to Cart
                    </button>
                    <button className="btn btn-warning pt-1 mt-gap">
                      <i className="fa fa-inr">85</i>
                    </button>
                    <button className="btn btn-primary pt-1 mt-gap color-white">
                      <a href="/services/products/productdesc">
                        View Products
                      </a>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

  );
};

export default products;
